import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import axios from "axios";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 300,
    },
}));

export default function VatReportsOneTableSale(props) {
    const { data, isPrint, showtab3vat } = props;
    const stylH = {
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: isPrint ? "#000" : "#fff"
    }
    const stylH1 = {
        BorderBottom: "solid 0.5px",
        borderColor: "#000",
        fontFamily: "Amiri-Regular",
        fontWeight: 900,
        fontSize: 15,
        color: isPrint ? "#000" : "#fff"
    }
    const stylRo = {
        border: "solid 0.5px",
        borderColor: "#000",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000"
    }
    const { t } = useTranslation(["forms"]);
    const classes = useStyles();

    return (
        <TableContainer component={Paper} >
            <Table
                //className={classes.table} 
                size="small" aria-label="a dense table" >
                <TableHead>

                    <TableRow
                        style={{
                            backgroundColor: isPrint ? "#d3d3d3" : colors.green[300],
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >

                        <TableCell style={stylH1} align="center" colSpan={showtab3vat ? 8 : 6} >
                            {t("vat-sales")}
                        </TableCell>

                    </TableRow>
                    <TableRow
                        style={{
                            backgroundColor: isPrint ? "#d3d3d3" : colors.green[300],
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 15,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} align="center">
                            {""}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("sales")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"مردود مبيعات"}
                        </TableCell>
                        {showtab3vat &&
                            <TableCell style={stylH} align="center">
                                {"تبغ مبيعات"}
                            </TableCell>
                        }
                        <TableCell style={stylH} align="center">
                            {t("sales-tax")}
                        </TableCell>
                        {showtab3vat &&
                            <TableCell style={stylH} align="center">
                                {"تبغ مردود"}
                            </TableCell>
                        }
                        <TableCell style={stylH} align="center">
                            {t("return-tax")}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {t("tax-settlement")}
                        </TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row) => (
                        <TableRow key={row.id}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                border: "solid 0.6px"
                            }}
                        >
                            <TableCell style={stylRo} align="right" >{t("sales")}</TableCell>
                            <TableCell style={stylRo} align="right" >{parseFloat(row?.SaleVal).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.RT_SaleeVal).toFixed(2)}</TableCell>
                            {showtab3vat &&
                                <TableCell style={stylRo} align="center" > {parseFloat(row?.SaleTAB3).toFixed(2)}</TableCell>
                            }
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.SaleTax).toFixed(2)}</TableCell>
                            {showtab3vat &&
                                <TableCell style={stylRo} align="center" > {parseFloat(row?.RT_SaleTAB3).toFixed(2)}</TableCell>
                            }
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.RT_SaleTax).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.SaleTax - row?.RT_SaleTax).toFixed(2)}</TableCell>


                        </TableRow>
                    ))}
                </TableBody>
                <TableBody>
                    {data.map((row) => (
                        <TableRow key={row.id}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                border: "solid 0.6px"
                            }}
                        >
                            <TableCell style={stylRo} align="right" >{"عمليات اخرى"}</TableCell>
                            <TableCell style={stylRo} align="right" >{parseFloat(row?.Rest_SaleVal).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.Rest_RT_SaleeVal).toFixed(2)}</TableCell>
                            {showtab3vat &&
                                <TableCell style={stylRo} align="center" > {"0.0"}</TableCell>
                            }
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.Rest_SaleTax).toFixed(2)}</TableCell>
                            {showtab3vat &&
                                <TableCell style={stylRo} align="center" > {"0.0"}</TableCell>
                            }
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.Rest_RT_SaleTax).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.Rest_SaleTax - row?.Rest_RT_SaleTax).toFixed(2)}</TableCell>


                        </TableRow>
                    ))}
                </TableBody>

                <TableBody>
                    {data.map((row) => (
                        <TableRow key={row.id}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                border: "solid 0.6px"
                            }}
                        >
                            <TableCell style={stylRo} align="right" >{t("total")}</TableCell>
                            <TableCell style={stylRo} align="right" >{parseFloat(row?.SaleVal + row?.Rest_SaleVal).toFixed(2)}</TableCell>

                            <TableCell style={stylRo} align="center" > {parseFloat(row?.RT_SaleeVal + row?.Rest_RT_SaleeVal).toFixed(2)}</TableCell>
                            {showtab3vat &&
                                <TableCell style={stylRo} align="center" > {parseFloat(row?.SaleTAB3).toFixed(2)}</TableCell>
                            }
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.SaleTax + row?.Rest_SaleTax).toFixed(2)}</TableCell>
                            {showtab3vat &&
                                <TableCell style={stylRo} align="center" > {parseFloat(row?.RT_SaleTAB3).toFixed(2)}</TableCell>
                            }
                            <TableCell style={stylRo} align="center" > {parseFloat(row?.RT_SaleTax + row?.Rest_RT_SaleTax).toFixed(2)}</TableCell>
                            <TableCell style={stylRo} align="center" > {(parseFloat(row?.SaleTax - row?.RT_SaleTax) + parseFloat(row?.Rest_SaleTax - row?.Rest_RT_SaleTax)).toFixed(2)}</TableCell>


                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
